export const SHOW_ON_LOAN_TITLE = 'Show on loan';

export const SELECT_ALL_LABEL = 'Select all';

export const LAST_CHANGE_PREFIX = 'Last change';

export const AI_INITIALS = 'AI';
